import { useEffect } from "react";
import { EmailLinkForm } from "./EmailLinkForm";

interface SaveAccountModalProps {
  apiUrl: string;
  onClose: () => void;
}

/**
 * Opened from an anonymous profile's "add your email" prompt. An anonymous
 * account lives only in this browser's storage; once an email is attached,
 * the login page can bring it back anywhere.
 */
export function SaveAccountModal({ apiUrl, onClose }: SaveAccountModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <dialog open className="save-account-modal" onClick={onClose}>
      <article
        role="dialog"
        aria-modal="true"
        aria-labelledby="save-account-title"
        onClick={(e) => e.stopPropagation()}
      >
        <header>
          <button type="button" aria-label="Close" rel="prev" onClick={onClose} />
          <h3 id="save-account-title">Save your account</h3>
        </header>
        <p>
          Right now your designs are saved only in this browser. Clear its
          storage or switch devices and they're gone.
        </p>
        <p>
          Add your email and we'll send you a link. Click it to attach the
          email to this account, then log in with it from any device to get
          your designs back.
        </p>
        <EmailLinkForm apiUrl={apiUrl} submitLabel="Email me a link" />
      </article>
    </dialog>
  );
}
